// packages/components/src/sprint/LiveGoalTracker.tsx

import React from 'react';
import { motion } from 'framer-motion';
import { Icon, type IconName } from '@dopomogai/ui';

interface LiveGoalTrackerProps {
  label: string;
  currentValue?: number;
  goalValue?: number;
  iconName?: IconName; // THE FIX: Make iconName optional
  index?: number;
}

export const LiveGoalTracker: React.FC<LiveGoalTrackerProps> = ({
  label,
  currentValue = 0,
  goalValue = 0,
  iconName = 'Target', // THE FIX: Provide a sensible default icon
  index = 0,
}) => {
  const percentage = goalValue > 0 ? (currentValue / goalValue) * 100 : 0;

  return (
    <motion.div
      className="p-4 bg-white border-2 border-black rounded-lg shadow-[4px_4px_0_0_black]"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0, transition: { delay: index * 0.1 } }}
    >
      <div className="flex items-center">
        <Icon name={iconName} className="h-6 w-6 text-emerald-500 mr-4 flex-shrink-0" />
        <div className="w-full">
          <p className="font-semibold text-gray-800 truncate">{label}</p>
          <p className="text-sm text-slate-500">
            <span className="font-bold text-gray-900">
              {currentValue.toLocaleString()}
            </span>
            {' / '}
            {goalValue.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="mt-2 w-full bg-slate-200 rounded-full h-2 overflow-hidden">
        <motion.div
          className="bg-emerald-500 h-2 rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(percentage, 100)}%` }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        />
      </div>
    </motion.div>
  );
};